export interface JsonBatchUpdateContextWeekTypeHistory {
  id: number;
  fileName: string;
  status: {
    idStatus: string;
    label: string;
  };
  integrationDate: string;
  idTvChannel: number;
  utCode: string;
  reportName: string | null;
  fileType: {
    idFileType: number;
    name: string;
  };
}

export class BatchUpdateContextWeekTypeHistory {
  id: number;
  fileName: string;
  integrationDate: Date;
  step: {
    idStatus: string;
    label: string;
  };
  idTvChannel: number;
  ut: string;
  reportDownloadLink?: string;

  constructor(json: JsonBatchUpdateContextWeekTypeHistory) {
    this.id = json.id;
    this.fileName = json.fileName;
    this.integrationDate = new Date(json.integrationDate);
    this.step = json.status;
    this.idTvChannel = json.idTvChannel;
    this.ut = json.utCode;
    this.reportDownloadLink = json.reportName ?? undefined;
  }
}
